export const saveRegistration = async ({ baseURL, projectId, email, name, fingerprint, campaign, captchaToken }) => {
    const url = `${baseURL}/api/public/project/campaign/giveaway`;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({ projectId, email, name, fingerprint, campaign, captchaToken }),
    });
    if (!response.ok) {
        throw new Error('Error registering');
    }
    return response;
};

export const checkIfFingerprintJSIsBlocked = async () => {
    const url = 'https://eu.api.fpjs.io/';
    try {
        await fetch(url, { method: 'HEAD' });
        return false;
    } catch (e) {
        return true;
    }
};
